<template>
  <button
    type="button"
    aria-label="Like"
    :aria-pressed="liked"
    @click="toggleLike"
    :class="[
      'flex items-center border-0 bg-transparent p-0 cursor-pointer',
      liked && 'text-[#ed4956]',
      isAnimating && 'like-animating',
    ]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="w-10 h-10 transition-colors duration-200 ease-out"
      :fill="liked ? 'currentColor' : 'none'"
      stroke="currentColor"
      stroke-width="1.5"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
           2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09
           C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42
           22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps({
  liked: Boolean,
})

const emit = defineEmits(['update:liked'])

const isAnimating = ref(false)

function toggleLike() {
  const next = !props.liked
  emit('update:liked', next)

  if (next) {
    // reset animation
    isAnimating.value = false

    requestAnimationFrame(() => {
      isAnimating.value = true
    })
  }
}
</script>

<style scoped>
.like-animating svg {
  animation: like-pop 450ms cubic-bezier(0.2, 0.8, 0.4, 1);
}

@keyframes like-pop {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.35);
  }
  55% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
